<template>
  <el-main class='main' style="height: calc(100vh - 56px - 20px)">
    <el-input v-model="name" placeholder="请输入名称" style="width: 200px;"></el-input>
    <el-button type="success" @click="query" icon="el-icon-search" style="float: right;background-color: #209323;">查询</el-button>
    <el-button @click="digAdd" icon="el-icon-plus" style="float: right;margin-right: 10px;">添加</el-button>
    <el-table
      :data='tableData'
      style="width: 100%; margin-top: 10px;">
      <el-table-column
        fixed
        prop= 'id'
        label= '编号'
        width= '80'>
      </el-table-column>
      <el-table-column
        prop= 'deviceInstantiation'
        label= '设备实例'
        width= '140'>
        <template slot-scope='scope'>
          {{ scope.row.deviceInstantiation?scope.row.deviceInstantiation.name:'' }}
        </template>
      </el-table-column>
      <el-table-column
        prop= 'deviceModelProperty'
        label= '设备指令'
        width= '140'>
        <template slot-scope='scope'>
          {{ scope.row.deviceModelProperty?scope.row.deviceModelProperty.name:'' }}
        </template>
      </el-table-column>
      <el-table-column
        prop= 'deviceModelProperty'
        label= '规则'
        width= '240'>
        <template slot-scope='scope'>
          执行 {{ scope.row.val }}{{ scope.row.deviceModelProperty?scope.row.deviceModelProperty.unit:'' }}
        </template>
      </el-table-column>
      <el-table-column
        prop= 'type'
        label= '状态'
        width= '120'>
        <template slot-scope='scope'>
          <el-button type='success' size='small' v-if="scope.row.type===1">实现控制</el-button>
          <el-button type='warn' size='small' v-if="scope.row.type===2">场景控制</el-button>
          <el-button type='danger' size='small' v-if="scope.row.type===9">发送消息</el-button>
        </template>
      </el-table-column>
      <el-table-column
        prop= 'status'
        label= '状态'
        width= '120'>
        <template slot-scope='scope'>
          <el-button type='success' size='small' v-if="scope.row.status===1">启用</el-button>
          <el-button type='danger' size='small' v-if="scope.row.status===0">禁用</el-button>
        </template>
      </el-table-column>
      <el-table-column
        prop= 'descr'
        label= '描述'>
      </el-table-column>

      <el-table-column
        fixed= 'right'
        label= '操作'
        width= '100'>
        <template slot-scope='scope'>
          <el-button @click='digEdit(scope.row)' type='text' size='small' style="color: #209323">编辑</el-button>
          <el-popover
            :ref="'delRef-'+scope.row.id"
            placement="right"
            width="160"
            trigger="click">
            <p>确定【编号:{{scope.row.id}}】删除吗？</p>
            <div style="text-align: right; margin: 0">
              <el-button size="mini" type="text" @click="delClose(scope.row)">取消</el-button>
              <el-button type="primary" size="mini" style="background-color: #209323;" @click="del(scope.row)">确定</el-button>
            </div>
            <el-button slot="reference" type='text' size='small' style="color: #f56c6c">删除</el-button>
          </el-popover>
        </template>
      </el-table-column>
    </el-table>
    <el-row style="text-align: right;margin-top: 20px;">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="current"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </el-row>
    <el-dialog title="操作表单" :visible.sync="dialogFormVisible" :modal="false">
      <el-form :model="form" :rules="rules" ref="form">
        <el-form-item label="控制规则ID" :label-width="formLabelWidth" prop="deviceControlRuleId">
          <el-input type="number" v-model.number="form.deviceControlRuleId" autocomplete="off" readonly disabled></el-input>
        </el-form-item>
        <el-row>
          <el-col :span="12">
            <el-form-item label="控制类型" :label-width="formLabelWidth">
              <el-radio v-model="type" :label=1 @input="choseType">实现控制</el-radio>
              <el-radio v-model="type" :label=9 @input="choseType">发送消息</el-radio>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="状态" :label-width="formLabelWidth" prop="status">
              <el-radio v-model="form.status" :label=1>启用</el-radio>
              <el-radio v-model="form.status" :label=0>禁用</el-radio>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="form.type==1">
          <el-col :span="12">
            <el-form-item label="设备实例ID" :label-width="formLabelWidth" prop="deviceInstantiationId">
              <el-select v-model="form.deviceInstantiationId" placeholder="请选择" @change="queryDeviceModelPerproties">
                <el-option v-for="item in deviceInstantiations" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="设备属性ID" :label-width="formLabelWidth" prop="deviceModelPropertyId">
              <el-select v-model="form.deviceModelPropertyId" placeholder="请选择" @change="choseSureDeviceModelPerproty">
                <el-option v-for="item in deviceModelPerproties" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="执行类型" :label-width="formLabelWidth" prop="symbol">
              <el-radio v-model="form.doType" :label=1>满足时执行</el-radio>
              <el-radio v-model="form.doType" :label=0>不满足时执行</el-radio>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="form.type==1">
            <el-form-item label="设定值" :label-width="formLabelWidth" prop="val">
              <el-input v-model="form.val" autocomplete="off" v-if="choseDeviceModelPerproty.dataType==='string'||choseDeviceModelPerproty.dataType==='integer'||choseDeviceModelPerproty.dataType==='float'"></el-input>
              <el-radio v-model="form.val" :label="true" v-if="choseDeviceModelPerproty.dataType==='boolean'">开启</el-radio>
              <el-radio v-model="form.val" :label="false" v-if="choseDeviceModelPerproty.dataType==='boolean'">关闭</el-radio>
              <el-radio v-model="form.val"  v-for="enmuValue in choseDeviceModelPerproty.enmuValues"  :key="enmuValue" :label="enmuValue" v-if="choseDeviceModelPerproty.dataType==='enmu'">{{ enmuValue }}</el-radio>              
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="form.type==9">
            <el-form-item label="消息类型" :label-width="formLabelWidth" prop="val">
              <el-radio v-model="form.val" label='weixin'>微信消息</el-radio>
              <el-radio v-model="form.val" label='sim'>手机消息</el-radio>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="描述" :label-width="formLabelWidth" prop="descr">
          <el-input v-model="form.descr" autocomplete="off" type="textarea" :rows="6"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('form')" style="background-color: #209323;" >确 定</el-button>
      </div>
    </el-dialog>
  </el-main>
</template>
<script>
import requestService from '../../../util/request'
export default {
  props: {
    deviceControlRuleId: {
      type: Number,
      default: 0,
      required: false
    },
    deviceInstantiationGroupId: {
      type: Number,
      default: 0,
      required: false
    }
  },
  watch: {
    deviceControlRuleId: {
      handler (newV, oldV) {
        this.form.deviceControlRuleId = newV
        console.log(this.form)
        this.query()
      },
      immediate: true
    },
    deviceInstantiationGroupId: {
      handler (newV, oldV) {
        this.deviceInstantiationGroupId = newV
        this.query()
        this.queryDeviceInstantiations(this.deviceInstantiationGroupId)
      },
      immediate: true
    }
  },
  data () {
    return {
      
      tableData: [],
      name: '',
      dialogFormVisible: false,
      form: {
        id: null,
        addTime: null,
        upTime: null,
        descr: null,
        status: null,
        deviceInstantiationId: null,
        deviceModelPropertyId: null,
        deviceControlRuleId: null,
        deviceControlSenceId: null,
        type: 1
      },
      type: 0,
      rules: {
        status: [{ type: 'integer', message: '需要整型数据类型', trigger: ['change', 'blur'] }, { required: true, message: '状态 不能为空', trigger: ['change', 'blur'] }],
        deviceInstantiationId: [{ type: 'integer', message: '需要整型数据类型', trigger: ['change', 'blur'] }, { required: true, message: '设备实例ID 不能为空', trigger: ['change', 'blur'] }],
        deviceModelPropertyId: [{ type: 'integer', message: '需要整型数据类型', trigger: ['change', 'blur'] }, { required: true, message: '设备属性ID 不能为空', trigger: ['change', 'blur'] }],
        deviceControlRuleId: [{ type: 'integer', message: '需要整型数据类型', trigger: ['change', 'blur'] }],
        deviceControlSenceId: [{ type: 'integer', message: '需要整型数据类型', trigger: ['change', 'blur'] }],
        val: [{ required: true, message: '设定值 不能为空', trigger: ['change', 'blur'] }, { message: '设定值 长度范围:[0,32]', min: 0, max: 32, trigger: ['change', 'blur'] }],
        doType: [{ type: 'integer', message: '需要整型数据类型', trigger: ['change', 'blur'] }, { required: true, message: '执行类型 不能为空', trigger: ['change', 'blur'] }],
        type: [{ type: 'integer', message: '需要整型数据类型', trigger: ['change', 'blur'] }, { required: true, message: '控制类型 不能为空', trigger: ['change', 'blur'] }]
      },
      formLabelWidth: '120px',
      current: 1,
      pageSize: 10,
      total: 0,
      pages: 0,
      deviceInstantiationGroups: [],
      deviceInstantiations: [],
      deviceModelPerproties: [],
      choseDeviceInstantiation: {},
      choseDeviceModelPerproty: {}
    }
  },
  created () {
    
    this.query()
  },
  methods: {
    choseType (e) {
      this.form.type = e
    },
    queryDeviceInstantiations (deviceInstantiationGroupId, deviceInstantiationId) {
      let that = this
      that.deviceInstantiations = []
      that.deviceModelPerproties = []
      if (!deviceInstantiationId) {
        that.form.deviceInstantiationId = 0
        that.form.deviceModelPropertyId = 0
      }
      requestService.get(`/deviceInstantiation/listPage?current=1&pageSize=1024000&deviceInstantiationGroupId=${deviceInstantiationGroupId}`, {
      }, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then((res) => {
        that.deviceInstantiations = res.data.body.records
        if (deviceInstantiationId) {
          that.queryDeviceModelPerproties(deviceInstantiationId, that.form.deviceModelPropertyId)
        }
      })
    },
    queryDeviceModelPerproties (deviceInstantiationId, deviceModelPropertyId) {
      let that = this
      that.deviceModelPerproties = []
      that.choseDeviceInstantiation = {}
      if (!deviceModelPropertyId) {
        that.form.deviceModelPropertyId = 0
      }
      for (let deviceInstantiation of that.deviceInstantiations) {
        if (deviceInstantiation.id === deviceInstantiationId) {
          that.choseDeviceInstantiation = deviceInstantiation
        }
      }
      requestService.get(`/deviceModelProperty/version/listPage?current=1&pageSize=1024000&deviceProjectId=${that.choseDeviceInstantiation.deviceProjectId}&version=${that.choseDeviceInstantiation.deviceModelVersion}`, {
      }, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then((res) => {
        for(let item of res.data.body.records){
          if(item.method === 'R'){
            continue;
          }
          if(item.dataType==='enmu'){
            item.enmuValues = item.enmuList.split(',')
          }
          that.deviceModelPerproties.push(item);
        }
        if (deviceModelPropertyId) {
          that.choseSureDeviceModelPerproty(deviceModelPropertyId)
        }
      })
    },
    choseSureDeviceModelPerproty (deviceModelPropertyId) {
      this.$forceUpdate()
      let that = this
      that.choseDeviceModelPerproty = {}
      for (let deviceModelPerproty of that.deviceModelPerproties) {
        if (deviceModelPerproty.id === deviceModelPropertyId) {
          that.choseDeviceModelPerproty = deviceModelPerproty
        }
      }
    },
    del (row) {
      let that = this
      document.body.click()
      let params = {
        id: row.id
      }
      requestService.post('/deviceControlRuleAction/del', params, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then((res) => {
        that.query()
      })
    },
    delClose (row) {
      document.body.click()
    },
    query () {
      let that = this
      requestService.get(`/deviceControlRuleAction/listPage?current=${that.current}&pageSize=${that.pageSize}&deviceControlRuleId=${that.deviceControlRuleId}`, {
      }, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then((res) => {
        // console.log(res)
        that.tableData = res.data.body.records
        that.total = res.data.body.total
        that.pages = res.data.body.pages
      })
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.query()
    },
    handleCurrentChange (val) {
      this.current = val
      this.query()
    },
    digEdit (row = {}) {
      this.form = {...row}
      this.dialogFormVisible = true
    },
    digAdd () {
      this.form = {deviceControlRuleId: this.deviceControlRuleId}
      this.form.deviceControlSenceId = -1
      this.form.deviceInstantiationId = -1
      this.form.deviceModelPropertyId = -1
      this.form.type = 1
      this.dialogFormVisible = true
    },
    submitForm (formName) {
      let that = this
      this.$refs[formName].validate((valid) => {
        console.log(valid)
        if (valid) {
          that.dialogFormVisible = false
          console.log('add')
          let url = '/deviceControlRuleAction/add'
          if (that.form.id) {
            url = '/deviceControlRuleAction/edit'
          }
          requestService.post(url, that.form, {headers: {'Content-Type': 'application/json'}}).then((res) => {
            that.query()
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/org-manage-components/deviceControlRuleAction/Index.vue